import { useCallback } from "react";
import { useAppDispatch } from "@/redux/features/hooks";
import { useLogoutMutation } from "@/redux/services/auth/auth.api";
import { performLogout } from "@/lib/logout";
import { persistor } from "@/redux/store";

/**
 * The normal logout (POST /api/logout, then `clearUserState()`), for screens
 * outside the Sidebar such as the no-access and error pages (SFRESTO-164).
 * Never wipes localStorage wholesale.
 */
export const useLogout = () => {
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();
  return useCallback(async () => {
    await performLogout(dispatch, () => logout().unwrap());
    // Write the cleared state to storage before the caller reloads the page.
    await persistor.flush();
  }, [dispatch, logout]);
};
